module.exports = __webpack_public_path__ + "static/media/pling.d6ab02e6.mp3";